// extracted by mini-css-extract-plugin
module.exports = {"container":"SharedData_container_2tyvr"};